<template>
    <div>
        <el-button type="primary" @click="openFullScreen1" v-loading.fullscreen.lock="fullscreenLoading" style="display:none"></el-button>
        <el-form :inline="true" class="demo-form-inline">
			 <span @click="backList()" class="backuy"><i class="el-icon-back"></i></span>
                    <el-form-item label="应用类型:">
                        <span>{{currentDetailInfo.contestTypeStr}}</span>
                    </el-form-item>
                    <el-form-item label="应用面信息:">
                        <span v-show="currentDetailInfo.h">H:{{currentDetailInfo.h}}m  &nbsp; </span>
                        <span v-show="currentDetailInfo.w">W:{{currentDetailInfo.w}}m &nbsp; </span>
                        <span v-show="currentDetailInfo.d">D:{{currentDetailInfo.db}}m ~ {{currentDetailInfo.d}}m &nbsp; </span>
                        <span v-show="currentDetailInfo.w1">W1:{{currentDetailInfo.w1}}m &nbsp; </span>
                        <span v-show="currentDetailInfo.w2">W2:{{currentDetailInfo.w2}}m &nbsp; </span>
                    </el-form-item>
                    <el-form-item>
                        <span>{{colorFlag == 1 ? '单白' : '彩色'}}</span>
                    </el-form-item>
                    
                    <el-form-item label="参考项:" class="wid150">
                        <el-select v-model="chooseEchatType" multiple collapse-tags @change="initData">
                            <el-option v-for="item in echatTypeList" :key="item.value" :label="item.name" :value="item.value">{{item.name}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
               
        <div style="height:580px;width:100%;margin: 0;overflow-x: auto;overflow-y:hidden;">
			<div style="width:2400px">
            <div id="echarts_power" style="float: left;width:400px;height:680px;"></div>
          <div id="echarts_lightIntensity6" style="float: left;width:400px;height:680px;"></div>
           <div id="echarts_lightIntensity3" style="float: left;width:400px;height:680px;"></div>
           <div id="echarts_lightIntensity7" style="float: left;width:400px;height:680px;"></div>
          <div id="echarts_lightIntensity10" style="float: left;width:400px;height:680px;"></div>
          <div id="echarts_lightIntensity9" style="float: left;width:400px;height:680px;"></div>
        </div>
		</div>
    </div>
</template>

<script>
Array.prototype.map = function(fn, thisObj) {
  var scope = thisObj || window;
  var a = [];
  for ( var i=0, j=this.length; i < j; ++i ) {
    a.push(fn.call(scope, this[i], i, this));
  }
  return a;
};
export default {
  name: 'hello',
  data () {
    return {
      fullscreenLoading:false,
		currentDetailInfo:{},
		ids:'',
        echatTypeList : [
                { value: '1', name: '参考值'},
                { value: '2', name: '平均值'},
                { value: '3', name: '推荐·低'},
                { value: '4', name: '推荐·中'},
                { value: '5', name: '推荐·高'}],
        chooseEchatType:['1','2','3','4','5']
    }
  },
  props:['colorFlag','contestId','contestTypeStr'],
  mounted(){

  },
  methods: {
	openFullScreen1() {
    	this.fullscreenLoading = true;
	},
	getRandomColor(){
		return '#'+'0123456789abcdef'.split('').map(function(v,i,a){
    	return i>5 ? null : a[Math.floor(Math.random()*16)] }).join('');
	},	
	setContestDetetionIds(ids,request){
		this.ids = ids
		this.currentDetailInfo = request
	},
    generateArr(length,value){
        var dataArr = new Array(length);
        for(var i=0;i<dataArr.length;i++){
            dataArr[i] =value;
        }
        return dataArr;
    },
    backList(){
        this.$emit('backDetail');
    },
    initData(){
      this.openFullScreen1()
        
var myChartPower = this.$echarts.init(document.getElementById("echarts_power"));

var myChartLightIntensity3 = this.$echarts.init(document.getElementById("echarts_lightIntensity3"));
var myChartLightIntensity6 = this.$echarts.init(document.getElementById("echarts_lightIntensity6"));
var myChartLightIntensity7 = this.$echarts.init(document.getElementById("echarts_lightIntensity7"));
var myChartLightIntensity9 = this.$echarts.init(document.getElementById("echarts_lightIntensity9"));
var myChartLightIntensity10 = this.$echarts.init(document.getElementById("echarts_lightIntensity10"));




var xAxisData =[];

var powerColumnData =[];
var powerAssistData =[];

var lightIntensity3ColumnData =[];
var lightIntensity3AssistData =[];

var lightIntensity6ColumnData =[];
var lightIntensity6AssistData =[];

var lightIntensity7ColumnData =[];
var lightIntensity7AssistData =[];

var lightIntensity9ColumnData =[];
var lightIntensity9AssistData =[];

var lightIntensity10ColumnData =[];
var lightIntensity10AssistData =[];





var series =[];
var lightIntensity3Series =[];
var lightIntensity6Series =[];
var lightIntensity7Series =[];
var lightIntensity9Series =[];
var lightIntensity10Series =[];


		var refTypeStr = '1,2,3,4,5' 
        var temp = ''
        for(var i =0;i<this.chooseEchatType.length;i++){
            temp += this.chooseEchatType[i] + ","
        }
        refTypeStr = temp.substring(0,temp.length-1)
		
		var params = {
			detetionIds:this.ids,
			refTypeStr:refTypeStr
		}
		let self  = this

        this.$http.postQuery('/api/contestStatistics/contestIndexForSupplierJson/'+this.colorFlag+'/'+this.contestId,params,function(res){
			var data = res.data
          self.fullscreenLoading = false;
			console.log(data)
			var length = data.indexList.length;
				for(var i=0 ;i<data.indexList.length;i++){
					var contestIndexRef = data.indexList[i];
					xAxisData.push(contestIndexRef.refType);
					powerColumnData.push(contestIndexRef.power);
					powerAssistData.push(0);
					
					lightIntensity3ColumnData.push(contestIndexRef.lightIntensity3Max -contestIndexRef.lightIntensity3);
					lightIntensity3AssistData.push(contestIndexRef.lightIntensity3);
					
					lightIntensity6ColumnData.push(contestIndexRef.lightIntensity6Max - contestIndexRef.lightIntensity6);
					lightIntensity6AssistData.push(contestIndexRef.lightIntensity6);
					
					lightIntensity7ColumnData.push(contestIndexRef.lightIntensity7);
					lightIntensity7AssistData.push(0);
					
					lightIntensity9ColumnData.push(contestIndexRef.lightIntensity9);
					lightIntensity9AssistData.push(0);
					
					lightIntensity10ColumnData.push(contestIndexRef.lightIntensity10);
					lightIntensity10AssistData.push(0);
					
				
				}
				series.push({
				    name: '辅助',
				    type: 'bar',
				    stack:  '总量',
				    itemStyle: {
				        normal: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        },
				        emphasis: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        }
				    },
				    data: powerAssistData
				},{
				    name: '',
				    type: 'bar',
				    stack: '总量',
				  /*   label: {
				        normal: {
				            show: true,
				            position: 'inside'
				        }
				    }, */
				    itemStyle: {
				        normal: {
				            color: '#ED7D31'
				        }
				    },
				    data:powerColumnData
				});
				
				lightIntensity3Series.push({
				    name: '辅助',
				    type: 'bar',
				    stack:  '总量',
				    itemStyle: {
				        normal: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        },
				        emphasis: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        }
				    },
				    data: lightIntensity3AssistData
				},{
				    name: '',
				    type: 'bar',
				    stack: '总量',
				 /*    label: {
				        normal: {
				            show: true,
				            position: 'inside'
				        }
				    }, */
				    itemStyle: {
				        normal: {
				            color: '#ED7D31'
				        }
				    },
				    data:lightIntensity3ColumnData
				});
				
				
				lightIntensity6Series.push({
				    name: '辅助',
				    type: 'bar',
				    stack:  '总量',
				    itemStyle: {
				        normal: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        },
				        emphasis: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        }
				    },
				    data: lightIntensity6AssistData
				},{
				    name: '',
				    type: 'bar',
				    stack: '总量',
				 /*    label: {
				        normal: {
				            show: true,
				            position: 'inside'
				        }
				    }, */
				    itemStyle: {
				        normal: {
				            color: '#ED7D31'
				        }
				    },
				    data:lightIntensity6ColumnData
				});
				
				
				lightIntensity7Series.push({
				    name: '辅助',
				    type: 'bar',
				    stack:  '总量',
				    itemStyle: {
				        normal: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        },
				        emphasis: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        }
				    },
				    data: lightIntensity7AssistData
				},{
				    name: '',
				    type: 'bar',
				    stack: '总量',
				/*     label: {
				        normal: {
				            show: true,
				            position: 'inside'
				        }
				    }, */
				    itemStyle: {
				        normal: {
				            color: '#ED7D31'
				        }
				    },
				    data:lightIntensity7ColumnData
				});
				
				
				
				lightIntensity9Series.push({
				    name: '辅助',
				    type: 'bar',
				    stack:  '总量',
				    itemStyle: {
				        normal: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        },
				        emphasis: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        }
				    },
				    data: lightIntensity9AssistData
				},{
				    name: '',
				    type: 'bar',
				    stack: '总量',
				 /*    label: {
				        normal: {
				            show: true,
				            position: 'inside'
				        }
				    }, */
				    itemStyle: {
				        normal: {
				            color: '#ED7D31'
				        }
				    },
				    data:lightIntensity9ColumnData
				});
				
				
				lightIntensity10Series.push({
				    name: '辅助',
				    type: 'bar',
				    stack:  '总量',
				    itemStyle: {
				        normal: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        },
				        emphasis: {
				            barBorderColor: 'rgba(0,0,0,0)',
				            color: 'rgba(0,0,0,0)'
				        }
				    },
				    data: lightIntensity10AssistData
				},{
				    name: '',
				    type: 'bar',
				    stack: '总量',
				 /*    label: {
				        normal: {
				            show: true,
				            position: 'inside'
				        }
				    }, */
				    itemStyle: {
				        normal: {
				            color: '#ED7D31'
				        }
				    },
				    data:lightIntensity10ColumnData
				});
				
			
				if(data.detectionList){
					
					for(var i=0 ;i<data.detectionList.length;i++){
						var currentColor = self.getRandomColor()
						var objectPower ={type: 'line',smooth: true,color:currentColor};
						var objectLightIntensity3 ={type: 'line',smooth: true,color:currentColor};
						var objectLightIntensity6 ={type: 'line',smooth: true,color:currentColor};
						var objectLightIntensity7 ={type: 'line',smooth: true,color:currentColor};
						var objectLightIntensity9 ={type: 'line',smooth: true,color:currentColor};
						var objectLightIntensity10 ={type: 'line',smooth: true,color:currentColor};
					
						var detection = data.detectionList[i];
						objectPower.name= detection.posCode;
						objectPower.data = self.generateArr(length,detection.power);
						series.push(objectPower);
						
						
						objectLightIntensity3.name= detection.posCode;
						objectLightIntensity3.data = self.generateArr(length,detection.lightIntensity3);
						lightIntensity3Series.push(objectLightIntensity3);
						
						objectLightIntensity6.name= detection.posCode;
						objectLightIntensity6.data = self.generateArr(length,detection.lightIntensity6);
						lightIntensity6Series.push(objectLightIntensity6);
						
						objectLightIntensity7.name= detection.posCode;
						objectLightIntensity7.data = self.generateArr(length,detection.lightIntensity7);
						lightIntensity7Series.push(objectLightIntensity7);
						
						objectLightIntensity9.name= detection.posCode;
						objectLightIntensity9.data = self.generateArr(length,detection.lightIntensity9);
						lightIntensity9Series.push(objectLightIntensity9);
						
						
						objectLightIntensity10.name= detection.posCode;
						objectLightIntensity10.data = self.generateArr(length,detection.lightIntensity10);
						lightIntensity10Series.push(objectLightIntensity10);
						
					
						
					}
				}

				var option = {
						 backgroundColor: '#f6f6fd',
						  textStyle: {
		                      color: 'black',
		                      fontSize: 16
		                  },
					    title: {
					        text: '功率(w)',
					        left:'center',
					        textStyle:{ //设置主标题风格
					        	color:'black'//设置主标题字体颜色
					        	},				       
					       // sublink: 'http://e.weibo.com/1341556070/AjQH99che'
					    },
					     tooltip : {
					        trigger: 'axis',
					        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
					            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					        },
					         formatter: function (params) {
					        	 var str ='<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
					        		+ params[1].marker + params[1].name + ' ' +params[1].value
			                          + '</div>';
			                          
					        	 for(var i=2;i<params.length;i++){
					        		 var obj = params[i];
					        		 str += obj.marker +obj.seriesName + '：' + obj.value + '<br>'
					        	 }
					        	return str;
					        } 
					    }, 
					    grid: {
					        left: '3%',
					        right: '4%',
					        bottom: '3%',
					        containLabel: true
					    },
					    xAxis: {
					        type : 'category',
					        splitLine: {show:false},
					        data : xAxisData,
					        nameTextStyle: {
			                      color: 'black',
			                      fontSize: 14
			                  },
					    },
					    yAxis: {
					        type : 'value'
					    },
					    series: series
					};


				var optionLightIntensity3 = {
						backgroundColor: '#f6f6fd',
						title: {
					        text: '下45°(cd)',
					        left:'center',
					        textStyle:{ //设置主标题风格
					        	color:'black'//设置主标题字体颜色
					        },	
					    },
					    textStyle: {
		                      color: 'black',
		                      fontSize: 16
		                },
					     tooltip : {
					        trigger: 'axis',
					        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
					            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					        },
					        formatter: function (params) {
					        	var tar0 = params[0];
					            var tar = params[1];
					           var maxValue = tar0.value +tar.value;
					        	 var str ='<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
					        		+ tar.marker + tar.name + ' ' +tar0.value + '~'+maxValue
			                          + '</div>';
			                          
					        	 for(var i=2;i<params.length;i++){
					        		 var obj = params[i];
					        		 str += obj.marker +obj.seriesName + '：' + obj.value + '<br>'
					        	 }
					        	return str;
					        } 
					    }, 
					    grid: {
					        left: '3%',
					        right: '4%',
					        bottom: '3%',
					        containLabel: true
					    },
					    xAxis: {
					        type : 'category',
					        splitLine: {show:false},
					        data : xAxisData
					    },
					    yAxis: {
					        type : 'value'
					    },
					    series: lightIntensity3Series
					};
					
				
				var optionLightIntensity6 = {
						backgroundColor: '#f6f6fd',
					    title: {
					        text: '垂直上30°(cd)',
					        left:'center',
					        textStyle:{ //设置主标题风格
					        	color:'black'//设置主标题字体颜色
					        	},	
					        //subtext: 'From ExcelHome',
					       // sublink: 'http://e.weibo.com/1341556070/AjQH99che'
					    },
					    textStyle: {
		                      color: 'black',
		                      fontSize: 16
		                  },
					     tooltip : {
					        trigger: 'axis',
					        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
					            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					        },
					        formatter: function (params) {
					        	var tar0 = params[0];
					            var tar = params[1];
					           var maxValue = tar0.value +tar.value;
					        	 var str ='<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
					        		+ tar.marker + tar.name + ' ' +tar0.value + '~'+maxValue
			                          + '</div>';
			                          
					        	 for(var i=2;i<params.length;i++){
					        		 var obj = params[i];
					        		 str += obj.marker +obj.seriesName + '：' + obj.value + '<br>'
					        	 }
					        	return str;
					        } 
					    }, 
					    grid: {
					        left: '3%',
					        right: '4%',
					        bottom: '3%',
					        containLabel: true
					    },
					    xAxis: {
					        type : 'category',
					        splitLine: {show:false},
					        data : xAxisData
					    },
					    yAxis: {
					        type : 'value'
					    },
					    series: lightIntensity6Series
					};
					
				var optionLightIntensity7 = {
					    backgroundColor: '#f6f6fd',
					    textStyle: {
		                      color: 'black',
		                      fontSize: 16
		                  },
					    title: {
					        text: '下10°(cd)',
					        left:'center',
					        textStyle:{ //设置主标题风格
					        	color:'black'//设置主标题字体颜色
					        	},	
					        //subtext: 'From ExcelHome',
					       // sublink: 'http://e.weibo.com/1341556070/AjQH99che'
					    },
					     tooltip : {
					        trigger: 'axis',
					        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
					            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					        },
					        formatter: function (params) {
					        	 var str ='<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
					        		+ params[1].marker + params[1].name + ' ' +params[1].value
			                          + '</div>';
			                          
					        	 for(var i=2;i<params.length;i++){
					        		 var obj = params[i];
					        		 str += obj.marker +obj.seriesName + '：' + obj.value + '<br>'
					        	 }
					        	return str;
					        } 
					    }, 
					    grid: {
					        left: '3%',
					        right: '4%',
					        bottom: '3%',
					        containLabel: true
					    },
					    xAxis: {
					        type : 'category',
					        splitLine: {show:false},
					        data : xAxisData
					    },
					    yAxis: {
					        type : 'value'
					    },
					    series: lightIntensity7Series
					};
					
				var optionLightIntensity9 = {
						backgroundColor: '#f6f6fd',
						  textStyle: {
		                      color: 'black',
		                      fontSize: 16
		                  },
					    title: {
					        text: '垂直下10°水平左60°(cd)',
					        left:'center',
					        textStyle:{ //设置主标题风格
					        	color:'black'//设置主标题字体颜色
					        	},	
					        //subtext: 'From ExcelHome',
					       // sublink: 'http://e.weibo.com/1341556070/AjQH99che'
					    },
					     tooltip : {
					        trigger: 'axis',
					        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
					            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					        },
					        formatter: function (params) {
					        	var tar0 = params[0];
					            var tar = params[1];
					           var maxValue = tar0.value +tar.value;
					        	 var str ='<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
					        		+ tar.marker + tar.name + ' ' +tar0.value + '~'+maxValue
			                          + '</div>';
			                          
					        	 for(var i=2;i<params.length;i++){
					        		 var obj = params[i];
					        		 str += obj.marker +obj.seriesName + '：' + obj.value + '<br>'
					        	 }
					        	return str;
					        } 
					    }, 
					    grid: {
					        left: '3%',
					        right: '4%',
					        bottom: '3%',
					        containLabel: true
					    },
					    xAxis: {
					        type : 'category',
					        splitLine: {show:false},
					        data : xAxisData
					    },
					    yAxis: {
					        type : 'value'
					    },
					    series: lightIntensity9Series
					};
					
				var optionLightIntensity10 = {
						backgroundColor: '#f6f6fd',
						  textStyle: {
		                      color: 'black',
		                      fontSize: 16
		                  },
					    title: {
					        text: '垂直下10°水平右60°(cd)',
					        left:'center',
					        textStyle:{ //设置主标题风格
					        	color:'black'//设置主标题字体颜色
					        	},	
					        //subtext: 'From ExcelHome',
					       // sublink: 'http://e.weibo.com/1341556070/AjQH99che'
					    },
					     tooltip : {
					        trigger: 'axis',
					        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
					            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					        },
					        formatter: function (params) {
					        	var tar0 = params[0];
					            var tar = params[1];
					           var maxValue = tar0.value +tar.value;
					        	 var str ='<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
					        		+ tar.marker + tar.name + ' ' +tar0.value + '~'+maxValue
			                          + '</div>';
			                          
					        	 for(var i=2;i<params.length;i++){
					        		 var obj = params[i];
					        		 str += obj.marker +obj.seriesName + '：' + obj.value + '<br>'
					        	 }
					        	return str;
					        } 
					    }, 
					    grid: {
					        left: '3%',
					        right: '4%',
					        bottom: '3%',
					        containLabel: true
					    },
					    xAxis: {
					        type : 'category',
					        splitLine: {show:false},
					        data : xAxisData
					    },
					    yAxis: {
					        type : 'value'
					    },
					    series: lightIntensity10Series
					};
				
			
				
				myChartPower.clear();
				myChartLightIntensity3.clear();
				myChartLightIntensity6.clear();
				myChartLightIntensity7.clear();
				myChartLightIntensity9.clear();
				myChartLightIntensity10.clear();
				
				myChartPower.setOption(option);
				myChartLightIntensity3.setOption(optionLightIntensity3);
				myChartLightIntensity6.setOption(optionLightIntensity6);
				myChartLightIntensity7.setOption(optionLightIntensity7);
				myChartLightIntensity9.setOption(optionLightIntensity9);
				myChartLightIntensity10.setOption(optionLightIntensity10);
				
			
        })
    }
  }
}
</script>
<style>
    .top{
        margin-bottom: 20px;
        
    }
    .button{
            background-color: #5b65a1;
            border-radius: 4px;
            color: #fff;
            padding: 12px 20px;
            font-size: 14px;
            border: none;
            margin-right: 20px;
            cursor: pointer;
        }
    </style>